<template>
    <div class="configuracion-view">
        <ComingSoon :label="currentLabel" />
    </div>
</template>

<script>
import ComingSoon from "@/components/layout/ComingSoon.vue";

const TAB_LABELS = Object.freeze({
    roles: "Roles de usuarios",
    logo: "Logo",
    nombre: "Nombre",
    integraciones: "Integraciones",
});

export default {
    name: "Configuracion",
    components: {
        ComingSoon,
    },
    computed: {
        currentLabel() {
            const tab = this.$route.query.tab;
            return TAB_LABELS[tab] || "Configuración";
        },
    },
};
</script>

<style lang="scss" scoped>
.configuracion-view {
    padding: 16px;
}
</style>
